import React, { useState } from "react";
import { useSearchBox } from "react-instantsearch";

const connection = navigator.connection;
let timerId = undefined;
let timeout = 0;

updateTimeout();

function updateTimeout() {
  timeout = ["slow-2g", "2g"].includes(connection?.effectiveType) ? 200 : 200;
}

function queryHook(query, search) {
  if (timerId) {
    clearTimeout(timerId);
  }

  timerId = setTimeout(() => search(query), timeout);
}

// Custom Search Box Component
const AlgoliaSearchField = ({
  onFocus = () => {},
  onBlur = () => {},
  onChange = () => {},
}) => {
  const { refine } = useSearchBox({ queryHook });
  const [searchText, setSearchText] = useState("");

  return (
    <div className="relative max-w-sm">
      <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <svg
          className="w-4 h-4 text-gray-500 dark:text-gray-400"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
          />
        </svg>
      </div>
      <input
        type="search"
        id="default-search"
        className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-full bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        placeholder="Search for users..."
        value={searchText}
        onChange={(e) => {
          const text = e.target.value;
          onChange(text);
          setSearchText(text);
          if (text === "") return;
          refine(text);
        }}
        onFocus={(e) => onFocus(e.target.value)}
        onBlur={(e) =>
          setTimeout(() => {
            onBlur(e.target.value);
          }, 300)
        }
      />
      {searchText !== "" && (
        <button
          onClick={() => {
            setSearchText("");
          }}
          className="text-white absolute end-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:outline-none font-medium rounded-full text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-800 dark:focus:ring-blue-800"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default AlgoliaSearchField;
